import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useUiConfig } from "../../../../hooks/useUiConfig.js";
import { ls } from "../../../../strings.js";
export const HelpText = () => {
    const supportUrl = useUiConfig(({ supportUrl }) => supportUrl);
    if (!supportUrl)
        return null;
    return (_jsxs("div", { className: "flex flex-row gap-1 justify-center mb-2", children: [_jsx("span", { className: "text-fg-tertiary text-xs", children: ls.loadingPasskey.supportText }), _jsx("a", { href: supportUrl, className: "text-btn-primary text-xs underline", children: ls.loadingPasskey.supportLink })] }));
};
//# sourceMappingURL=help-text.js.map